// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"F1f","hidden":"F1b-","bottomIntend":"F1zr","closeBtnWrap":"F1zt","closeBtn":"F1cx"};